import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';

import { SupportTicketModalComponent } from './support-ticket-modal.component';

export const SUPPORT_TICKET_MODAL_ID = 'support-ticket-modal';

@Injectable()
export class SupportTicketModalActionService {

  constructor(
    private overlay: Overlay,
    private dialog: MatDialog
  ) { }

  get reference(): MatDialogRef<SupportTicketModalComponent, unknown> | undefined {
    return this.dialog.getDialogById(SUPPORT_TICKET_MODAL_ID);
  }

  get instance(): MatDialogRef<SupportTicketModalComponent, unknown> {
    if (!this.reference) throw 'Dialog does not exist.';
    return this.reference;
  }

  open(): MatDialogRef<SupportTicketModalComponent, unknown> {
    const dialog = this.dialog.getDialogById(SUPPORT_TICKET_MODAL_ID);
    if (dialog) return dialog;
    return this.dialog.open(SupportTicketModalComponent, {
      closeOnNavigation: true,
      autoFocus: 'dialog',
      id: SUPPORT_TICKET_MODAL_ID,
      panelClass: SUPPORT_TICKET_MODAL_ID + '-overlay-panel',
      width: '500px',
      minWidth: 0,
      maxWidth: '95%',
      minHeight: 0,
      maxHeight: '100vh',
      scrollStrategy: this.overlay.scrollStrategies.noop()
    });
  }

  close(value?: boolean): void {
    const dialog = this.dialog.getDialogById(SUPPORT_TICKET_MODAL_ID);
    if (dialog) return dialog.close(value);
  }

}
